import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { FilteredBlocks } from '../../ui-kit/BaseFiltration/FilteredBlocks.js';
import { FiltrationForm } from '../../ui-kit/BaseFiltration/FiltrationForm.js';
import { useFiltrationForm } from '../../ui-kit/BaseFiltration/useFiltrationForm.js';
import { useHotFilters } from '../../ui-kit/BaseFiltration/useHotFilters.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { TabsControl } from '../../ui-kit/TabsControl/TabsControl.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
const initialFiltrationState = {
    categories: [],
    extraOptions: [],
    propertyType: [],
    stage: [],
};
export const MortgageFiltration = UniBlock(({ className, hotFilters, filtrationSchema = {}, resetButton, ...rest }) => {
    const [filtrationState, { blocksToRender }, { field, reset, update: replaceFiltrationState }] = useFiltrationForm(initialFiltrationState, {
        block: rest.block,
        page: rest.options?.page,
    });
    const handleFiltrationStateChange = useCallback((_ = initialFiltrationState) => replaceFiltrationState(_), []);
    const tabsControlProps = useHotFilters({
        hotFilters,
        filtrationState,
        blocks: rest.block?.blocks,
        onFiltrationStateChange: handleFiltrationStateChange,
    });
    return (_jsxs(BlockWrapper, { className: style('space-y-2xs', className), defaultPadding: "p-0", version: "transparent", ...rest, children: [_jsx(TabsControl, { ...tabsControlProps }), _jsx(FiltrationForm, { filtrationSchema: filtrationSchema, resetButton: resetButton, field: field, reset: reset }), _jsx(FilteredBlocks, { blocksToRender: blocksToRender, ...rest })] }));
}, {
    childrenTypes: ['ProductBlock'],
    childSchema: (content) => content?.filtrationSchema || {},
});
//# sourceMappingURL=MortgageFiltration.js.map